export default {
	getMailBoxes: state => state.mailBoxes,
	getMailBox: state => state.mailBox,
};
